import React, { useRef } from "react";

const ColorPicker = ({ onChange = () => {}, value, onClick = () => {} }) => {
  const timerRef = useRef(null);

  const handleChange = (newColor) => {
    const colorValue = newColor.target.value;

    if (!!timerRef.current) clearTimeout(timerRef.current);

    timerRef.current = setTimeout(() => {
      onChange(colorValue);
    }, 200);
  };

  return (
    <input
      type="color"
      id="colorPicker"
      name="colorPicker"
      value={value}
      onChange={handleChange}
      onClick={onClick}
    />
  );
};

export default ColorPicker;
